import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { label } from '../constants/labels';
import { message } from '../constants/messages';
import { BaseAPIService } from '@app/Services/api.base.service';
import { ValidateRulesService } from '@app/shared/validate-rules.service';
import { IGridCols } from '../Models/IGridCols';
import { IBroadcastMessage } from '../Models/IBroadcastMessage';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-broadcast-message',
  standalone: false,
  templateUrl: './broadcast-message.component.html',
  styleUrls: ['./broadcast-message.component.scss'],
  providers: [MessageService, DatePipe],

})
export class BroadcastMessageComponent implements OnInit {
  isLoading: boolean
  today: Date;
  labels: any;
  messages: any
  messageCols: Array<IGridCols>;
  broadcastMessages: IBroadcastMessage[];
  isPagination: boolean;
  noDataMessages: boolean;
  newBroadcastMessage: IBroadcastMessage = { id: null, from: null, to: null, message: '', isActive: true };
  formInvalid: boolean;
  isEdit: boolean;
  addEditModalHeader: string;
  showAddEditDialog: boolean;
  currentMessage: IBroadcastMessage;
  showDeleteModal: boolean;
  minDateValue: Date;
  fromDate: any;
  toDate: any;
  txtmessage: string;
  txtErrorMessage: string;
  constructor(
    private datePipe: DatePipe,
    private readonly messageService: MessageService,
    private readonly translate: TranslateService,
    private readonly baseService: BaseAPIService,
    private readonly validateService: ValidateRulesService) { }

  ngOnInit() {
    this.isLoading = true;
    this.today = new Date();
    this.minDateValue = this.today;
    this.labels = label;
    this.messages = message;
    this.messageCols = [

      { field: 'from', header: this.labels.fromdate, display: 'true', width: '15%' },
      { field: 'to', header: this.labels.todate, display: 'true', width: '15%' },
      { field: 'message', header: this.labels.broadcastMessage, display: 'true', width: '55%' },

      { field: 'isActive', display: 'false' }
    ];
    this.getBroadcastMessages();
  }
  getBroadcastMessages() {
    const apiUrl = '/BroadcastMessage/GetBroadcastMessages';
    this.baseService.GET(apiUrl)
      .subscribe((response: IBroadcastMessage[]) => {

        if (response && response.length > 0) {
          this.broadcastMessages = response;
          this.isPagination = this.broadcastMessages.length < 10 ? false : true;
        }
        else {
          this.broadcastMessages = null;
          this.noDataMessages = true;
          this.isPagination = false;
        }
        this.isLoading = false;
      });
  }

  ResetMessage() {
    this.newBroadcastMessage = {
      id: 0, from: null, to: null, message: '', isActive: true,
    };
    this.fromDate = undefined
    this.toDate = undefined
    this.txtmessage = ''
    this.formInvalid = true;
  }
  OnAddMessage() {
    this.ResetMessage();
    this.isEdit = false;
    this.addEditModalHeader = label.addBroadcastMessage;
    this.showAddEditDialog = true;
  }
  onReject() {
    this.messageService.clear('c');
  }
  isValidDateObject(value: any): boolean {
    return value instanceof Date && !isNaN(value.getTime());
  }
  OnSaveOrEditMessage() {
    this.messageService.clear('c');
    this.isLoading = true;
    const baseApi = '/BroadcastMessage/';
    this.newBroadcastMessage.from = this.isValidDateObject(this.fromDate) ?
      this.datePipe.transform(this.fromDate, 'dd-MMM-yyyy HH:mm') : this.fromDate;
    this.newBroadcastMessage.to = this.isValidDateObject(this.toDate) ?
      this.datePipe.transform(this.toDate, 'dd-MMM-yyyy HH:mm') : this.toDate;
    this.newBroadcastMessage.message = this.txtmessage
    let broadcastMessageAddUpdate = new Observable<any>();

    broadcastMessageAddUpdate = !this.isEdit
      ? this.baseService.PostWithHeaders(`${baseApi}CreatebroadcastMessage`, {}, this.newBroadcastMessage)
      : this.baseService.PutWithHeaders(`${baseApi}EditBroadcastMessage`, {}, this.newBroadcastMessage);

    broadcastMessageAddUpdate.subscribe((response) => {
      this.showAddEditDialog = false;
      switch (response) {
        case this.messages.DateOverlapMessage:
          this.messageService.add({ severity: 'warn', summary: this.translate.instant(this.messages.warning), detail: this.translate.instant(this.messages.dateoverlapuserMessage), key: 'warn' });
          break;
        case this.messages.existingBroadcastMessage:
          this.messageService.add({ severity: 'warn', summary: this.translate.instant(this.messages.warning), detail: this.translate.instant(this.messages.broadcastMessageActive), key: 'warn' });
          break;
        default:
          if (!this.isEdit) {

            this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: this.translate.instant(this.messages.broadcastMessage + " " + this.messages.reportAdd), key: 'success' });

          } else {
            this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: this.translate.instant(this.messages.broadcastMessage + " " + this.messages.reportUpdated), key: 'success' });
          }
          break;
      }
      this.getBroadcastMessages();
      this.isLoading = false;
    }, (error) => {
      this.showAddEditDialog = false;
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.createEditBroadcastMessageFailure), key: 'error' });
      this.isLoading = false;
    });
  }
  OnEditMessage(rowData: IBroadcastMessage) {
    this.showAddEditDialog = true;
    this.isEdit = true;
    this.formInvalid = true;
    this.addEditModalHeader = label.editBroadcastMessage;
    this.fromDate = new Date(rowData.from);
    this.toDate = new Date(rowData.to);
    this.txtmessage = rowData.message;
    this.newBroadcastMessage.id = rowData.id;

  }

  OnCancelAddEdit() {
    this.showAddEditDialog = false;
  }

  OnDeleteMessage(rowData: IBroadcastMessage) {
    this.currentMessage = rowData;
    this.showDeleteModal = true;
    this.messageService.clear();
  }
  OnMessageDeleteConfirm() {
    this.isLoading = true;
    this.showDeleteModal = false;
    const apiUrl = `/BroadcastMessage/DeleteBroadcastMessage/${this.currentMessage.id}`;
    this.baseService.DELETE(apiUrl).subscribe((response: boolean) => {
      if (response === true) {
        this.getBroadcastMessages();
        this.isLoading = false;
        this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: this.messages.broadcastMessage + " " + this.messages.deleteReport, key: 'success' });
      }
      else {
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.messages.deleteBroadcastMessageFailure, key: 'error' });
      }
    }, (error) => {
      this.isLoading = false;
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.messages.deleteBroadcastMessageFailure, key: 'error' });
    });
  }

  OnMessageDeleteReject() {
    this.showDeleteModal = false;
    this.messageService.clear();
  }

  onRejectToast() {
    this.messageService.clear('c');
  }
  public EditMessageStatus(rowdata: any, event: Event) {
    if (event !== null) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.isLoading = true;
    this.messageService.clear();

    this.baseService.PutWithHeaders(`/BroadcastMessage/UpdateBroadcastMessageState/${rowdata.id}`, {}).subscribe((response) => {
      this.isLoading = false;
      switch (response) {
        case this.messages.existingBroadcastMessage:
          rowdata.isActive = !rowdata.isActive;
          if (rowdata.isActive) {
            this.messageService.add({ severity: 'warn', summary: this.translate.instant(this.messages.success), detail: this.translate.instant(this.messages.activeMessageWarning), key: 'warn' });
          } else {
            this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: this.translate.instant(this.messages.deactiveReport), key: 'success' });
          }
          break;
        case true:
          rowdata.isActive = !rowdata.isActive;
          const msg = rowdata.isActive ? this.translate.instant(this.messages.activeReport) : this.translate.instant(this.messages.deactiveReport);
          this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: msg, key: 'success' });
          break;
        default:
          this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.error), detail: '', key: 'error' });
          break;

      }
    }, (error) => {
      this.isLoading = false;
      this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.error), detail: '', key: 'error' });
    });
  }
  public ValidateForm() {

    var IsValidDts = false;
    if (this.fromDate != undefined && this.toDate != undefined) {
      var frmdate = new Date(this.fromDate);
      IsValidDts = !isNaN(frmdate.getTime()) ? true : false;
      var todate = new Date(this.toDate);
      IsValidDts = !isNaN(todate.getTime()) ? true : false;
    }
    else {
      IsValidDts = true;
      return;
    }
    this.txtErrorMessage = this.validateService.requiredElement(this.txtmessage, 'broadcast message', 0, 4000);

    this.formInvalid = (this.txtErrorMessage == '' && IsValidDts) ? false : true;

  }
}
